module.exports = __webpack_public_path__ + "img/example_banner.a75ff8ba.png";